const domainName = process.env.REACT_APP_STATIC_DATA_DOMAIN_NAME;

export const STATIC_DATA_URL = `http://${domainName}`;
